var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleetShower01 = function SvgSleetShower01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sleet_shower-01_svg2__a",
    x1: 5.43,
    x2: 162.6,
    y1: 177.1,
    y2: 19.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet_shower-01_svg2__a",
    id: "sleet_shower-01_svg2__b",
    x1: 79.97,
    x2: 237.15,
    y1: 251.64,
    y2: 94.46
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet_shower-01_svg2__a",
    id: "sleet_shower-01_svg2__c",
    x1: 3.57,
    x2: 160.75,
    y1: 175.24,
    y2: 18.07
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet_shower-01_svg2__a",
    id: "sleet_shower-01_svg2__d",
    x1: 34.44,
    x2: 191.62,
    y1: 206.11,
    y2: 48.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet_shower-01_svg2__a",
    id: "sleet_shower-01_svg2__e",
    x1: 58.11,
    x2: 215.28,
    y1: 229.78,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet_shower-01_svg2__a",
    id: "sleet_shower-01_svg2__f",
    x1: -2.15,
    x2: 155.03,
    y1: 169.52,
    y2: 12.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet_shower-01_svg2__a",
    id: "sleet_shower-01_svg2__g",
    x1: 14.49,
    x2: 171.67,
    y1: 186.16,
    y2: 28.99
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet_shower-01_svg2__a",
    id: "sleet_shower-01_svg2__h",
    x1: 29.54,
    x2: 186.72,
    y1: 201.21,
    y2: 44.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet_shower-01_svg2__a",
    id: "sleet_shower-01_svg2__i",
    x1: 45.55,
    x2: 202.73,
    y1: 217.23,
    y2: 60.05
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet_shower-01_svg2__a",
    id: "sleet_shower-01_svg2__j",
    x1: 63.18,
    x2: 220.36,
    y1: 234.85,
    y2: 77.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet_shower-01_svg2__a",
    id: "sleet_shower-01_svg2__k",
    x1: 76,
    x2: 233.18,
    y1: 247.67,
    y2: 90.49
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M156.72 28.95c-3.22 0-6.51.44-9.99 1.32C138.24 11.77 120.09 0 99.59 0 76.88 0 56.98 14.53 50.06 36.15c-.63 1.96.45 4.05 2.41 4.67 1.96.63 4.05-.45 4.67-2.41C63.07 19.88 80.13 7.42 99.59 7.42c17.29 0 32.63 9.79 40.05 25.25-5.1 2.33-8.63 5.78-10.8 8.53a3.72 3.72 0 0 0 .62 5.22 3.707 3.707 0 0 0 5.22-.62c2.01-2.55 5.54-5.92 10.94-7.47.02 0 .1-.03.13-.04 3.96-1.29 7.55-1.92 10.98-1.92 19.64 0 35.63 15.98 35.63 35.63s-15.98 35.63-35.63 35.63H43.08c-14.8 0-26.84-12.04-26.84-26.83s12.04-26.84 26.84-26.84c2.19 0 4.47.36 7.18 1.12 3.56 1.07 6.86 3 9.3 5.43.73.72 1.67 1.08 2.62 1.08s1.91-.37 2.64-1.1a3.724 3.724 0 0 0-.01-5.26c-3.3-3.28-7.71-5.87-12.43-7.29h-.04c-.01 0-.02-.01-.03-.02-3.41-.95-6.34-1.4-9.23-1.4-18.9 0-34.27 15.37-34.27 34.27s15.37 34.27 34.27 34.27h113.64c23.75 0 43.06-19.32 43.06-43.06 0-23.75-19.32-43.06-43.06-43.06",
    style: {
      fill: "url(#sleet_shower-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.2 169.5c-7.14 0-12.92 5.78-12.92 12.92s5.78 12.92 12.92 12.92 12.91-5.78 12.91-12.92-5.78-12.91-12.91-12.92m0 19.21c-3.48 0-6.31-2.83-6.31-6.31s2.83-6.31 6.31-6.31 6.31 2.83 6.31 6.31-2.83 6.31-6.31 6.31",
    style: {
      fill: "url(#sleet_shower-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.13 152.76c-7.14 0-12.92 5.78-12.92 12.92s5.78 12.92 12.92 12.91c7.14 0 12.91-5.78 12.91-12.92-.01-7.13-5.79-12.9-12.92-12.91m.02 19.22c-3.48 0-6.31-2.83-6.31-6.31s2.81-6.31 6.3-6.31 6.31 2.81 6.32 6.3c0 3.48-2.83 6.31-6.31 6.32",
    style: {
      fill: "url(#sleet_shower-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.14 166.81c-8.62 0-15.59 6.98-15.59 15.59s6.99 15.59 15.59 15.59 15.59-6.98 15.59-15.59-6.99-15.58-15.59-15.59m0 24.59c-4.96 0-8.99-4.02-8.99-8.98s4.03-8.98 8.99-8.98a8.98 8.98 0 1 1 0 17.96",
    style: {
      fill: "url(#sleet_shower-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.49 126.14c-5.66 0-10.24 4.58-10.24 10.24s4.59 10.23 10.24 10.24c5.66 0 10.25-4.58 10.25-10.24s-4.59-10.24-10.25-10.24m0 13.88a3.64 3.64 0 1 1 0-7.28 3.64 3.64 0 0 1 0 7.28",
    style: {
      fill: "url(#sleet_shower-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.01 132.73 27.9 145.39c-.72.95-1.92 1.43-3.1 1.27-1.18-.18-2.19-.97-2.61-2.09-.44-1.12-.22-2.38.55-3.3l10.11-12.66a3.3 3.3 0 0 1 3.1-1.26c1.18.18 2.18.96 2.61 2.08s.22 2.39-.55 3.3",
    style: {
      fill: "url(#sleet_shower-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.87 161.9c-1.27 0-2.43-.72-2.98-1.87s-.39-2.51.39-3.49l14.28-17.88c1.14-1.42 3.22-1.66 4.64-.53s1.66 3.22.53 4.64l-14.28 17.88a3.32 3.32 0 0 1-2.58 1.25",
    style: {
      fill: "url(#sleet_shower-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.36 136.62-19.18 24.02c-1.14 1.42-3.22 1.66-4.64.53-1.42-1.14-1.66-3.22-.53-4.64l19.18-24.04c1.14-1.42 3.22-1.66 4.64-.53 1.42 1.14 1.66 3.22.53 4.64Z",
    style: {
      fill: "url(#sleet_shower-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.2 132.73-35.62 44.62a3.326 3.326 0 0 1-4.65.53 3.303 3.303 0 0 1-.51-4.64l35.62-44.62a3.324 3.324 0 0 1 4.64-.53c1.42 1.14 1.66 3.22.53 4.64Z",
    style: {
      fill: "url(#sleet_shower-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.15 156.22-33.95 42.53c-1.14 1.42-3.22 1.66-4.64.53-1.42-1.14-1.66-3.22-.53-4.64l33.95-42.53c1.14-1.42 3.22-1.66 4.64-.53a3.324 3.324 0 0 1 .53 4.64",
    style: {
      fill: "url(#sleet_shower-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.75 143.87-13.39 16.78c-1.14 1.42-3.22 1.66-4.64.53-1.42-1.14-1.66-3.22-.53-4.64l13.39-16.78c1.14-1.42 3.22-1.66 4.64-.53s1.66 3.22.53 4.64",
    style: {
      fill: "url(#sleet_shower-01_svg2__k)"
    }
  }));
};
export default SvgSleetShower01;